import { useState, useEffect } from 'react';
import review1 from '../assets/review/1.png';
import review2 from '../assets/review/2.png';
import review3 from '../assets/review/3.png';
import review4 from '../assets/review/4.png';
import review5 from '../assets/review/5.png';
import review6 from '../assets/review/6.png';
import review7 from '../assets/review/7.png';
import review8 from '../assets/review/8.png';

const testimonials = [
    {
        id: 1,
        name: "SARAH",
        title: "SUSCRIPCIÓN IPTV PREMIUM",
        image: review1,
        text: "TVConnect ha transformado mi experiencia de streaming. La calidad 4K es excepcional y tengo acceso a todos mis contenidos favoritos en un solo lugar. La instalación fue simple y el soporte al cliente es reactivo. ¡Lo recomiendo encarecidamente!"
    },
    {
        id: 2,
        name: "MOHAMED",
        title: "STREAMING MULTIPANTALLA",
        image: review2,
        text: "¡Excelente servicio IPTV! Más de 79,000 canales con una calidad impecable. Puedo ver mis partidos de fútbol en directo sin ningún problema. La relación calidad-precio es inmejorable. ¡Servicio al cliente de primera!"
    },
    {
        id: 3,
        name: "EMMA",
        title: "VOD Y SERIES",
        image: review3,
        text: "Me encanta la biblioteca de películas y series. ¡Más de 249,000 contenidos disponibles! Nunca he estado tan satisfecha con un servicio de streaming. La interfaz es intuitiva y todo funciona perfectamente."
    },
    {
        id: 4,
        name: "DAVID",
        title: "CANALES DEPORTIVOS",
        image: review4,
        text: "Como fanático del deporte, necesito acceder a todos los canales deportivos. TVConnect me da acceso a Ligue 1 Plus y mucho más. La calidad HD/4K es perfecta. ¡Servicio muy profesional!"
    },
    {
        id: 5,
        name: "SOPHIE",
        title: "SUSCRIPCIÓN FAMILIAR",
        image: review5,
        text: "¡Perfecto para toda la familia! A mis hijos les encantan los canales infantiles y tenemos acceso a Netflix, Disney+ y mucho más. La activación fue inmediata y el soporte siempre está disponible. ¡Gracias TVConnect!"
    },
    {
        id: 6,
        name: "ALEX",
        title: "STREAMING ULTRARRÁPIDO",
        image: review6,
        text: "¡La velocidad de conexión es impresionante! Los canales se cargan en menos de 0.5 segundos. También aprecio la compatibilidad con todos mis dispositivos. El mejor servicio IPTV que he probado hasta ahora."
    },
    {
        id: 7,
        name: "LUCAS",
        title: "CALIDAD 4K",
        image: review7,
        text: "¡La calidad 4K es excepcional! Veo mis películas favoritas con una claridad perfecta. El catch-up y el EPG funcionan muy bien. Estoy muy satisfecho con mi suscripción. ¡Lo recomiendo al 100%!"
    },
    {
        id: 8,
        name: "MARIE",
        title: "SERVICIO AL CLIENTE PREMIUM",
        image: review8,
        text: "Lo que más me impresiona es el servicio al cliente. Siempre disponible y muy competente. Tuve una pequeña pregunta técnica y me ayudaron en menos de 10 minutos. ¡Servicio excepcional, continuaré!"
    }
];

export default function Review() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const currentTestimonial = testimonials[currentIndex];

    // Auto-rotation toutes les 5 secondes
    useEffect(() => {
        const interval = setInterval(() => {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
                setIsTransitioning(false);
            }, 300);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const nextSlide = () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
            setIsTransitioning(false);
        }, 300);
    };

    const prevSlide = () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
            setIsTransitioning(false);
        }, 300);
    };

    const goToSlide = (index) => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentIndex(index);
            setIsTransitioning(false);
        }, 300);
    };

    return (
        <main className="relative overflow-hidden py-20">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 184, 0, 0.1) 0%, transparent 50%),
                                    radial-gradient(circle at 75% 75%, rgba(255, 184, 0, 0.1) 0%, transparent 50%)`,
                }}></div>
            </div>

            <div className="container mx-auto px-3 sm:px-5 relative z-10">
                {/* Header */}
                <div className="mb-16">
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
                        Opiniones de nuestros queridos clientes.
                    </h1>
                </div>

                {/* Main Content */}
                <div className="mb-12">
                    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 transition-opacity duration-300 ${isTransitioning ? 'opacity-50' : 'opacity-100'}`}>
                        {/* Left Side - Image/Video Card */}
                        <div className="relative">
                            <div className="bg-gradient-to-br from-blue-400/20 to-blue-600/20 backdrop-blur-md rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                                <div className="h-[200px] md:h-[350px]">
                                    <img 
                                        src={currentTestimonial.image} 
                                        alt={currentTestimonial.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Testimonial Content */}
                        <div className="flex flex-col justify-center">
                            <div className="h-full">
                                {/* Name */}
                                <h2 className="text-2xl md:text-3xl font-semibold text-white mb-1">
                                    {currentTestimonial.name}
                                </h2>

                                {/* Title */}
                                <p className="text-gray-400 text-xs md:text-sm font-semibold mb-1">
                                    {currentTestimonial.title}
                                </p>

                                {/* Location */}
                                <div className="flex items-center gap-3 mb-8">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 512 512"><mask id="SVGuywqVbel"><circle cx={256} cy={256} r={256} fill="#fff"></circle></mask><g mask="url(#SVGuywqVbel)"><path fill="#d80027" d="M0 0h512v128l-39.8 130.3L512 384v128H0V384l37.8-124L0 128z"></path><path fill="#ffda44" d="M0 128h512v256H0z"></path></g></svg>
                                    <span className='font-bold'>ES</span>
                                </div>

                                {/* Testimonial Text */}
                                <p className="text-gray-200 text-base md:text-lg leading-relaxed">
                                    {currentTestimonial.text}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Controls */}
                <div className="flex items-center justify-center gap-8 relative">
                    {/* Pagination Dots */}
                    <div className="flex items-center gap-2 absolute ">
                        {testimonials.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                                    index === currentIndex 
                                        ? 'bg-yellow-400 scale-125' 
                                        : 'bg-gray-400 hover:bg-gray-300'
                                }`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>

                    {/* Navigation Arrows */}
                    <div className="flex items-center gap-4 absolute right-0">
                        <button
                            onClick={prevSlide}
                            className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            aria-label="Previous testimonial"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M15.41 7.41L14 6l-6 6l6 6l1.41-1.41L10.83 12z"/>
                            </svg>
                        </button>
                        <button
                            onClick={nextSlide}
                            className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            aria-label="Next testimonial"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M10 6L8.59 7.41L13.17 12l-4.58 4.59L10 18l6-6z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    )
}

